'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}
const _=require('pulsar-utils/dist-es6/_');let

BaseTooltip=function(){function BaseTooltip(){_classCallCheck(this,BaseTooltip)}BaseTooltip.prototype.




factory=function factory(){
let templateCount=[this.templateUrl,this.template].filter(function(t){return _.exists(t)}).length;

if(templateCount>1){
throw new Error('cannot specify both "templateUrl" and "template"');
}

return{
restrict:'E',
templateUrl:this.templateUrl,
template:this.template,
link:{post:function(scope){return scope.$evalAsync()}}};

};_createClass(BaseTooltip,null,[{key:'type',get:function(){return'directive'}}]);return BaseTooltip}();


module.exports=BaseTooltip;
//# sourceMappingURL=baseTooltip.js.map
